"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuncInstallationUserError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const lodash_1 = require("lodash");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const depCheck_1 = require("../../../../error/depCheck");
const errorCode = "FuncInstallationError";
const messageKey = "driver.prerequisite.error.funcInstallationError";
class FuncInstallationUserError extends teamsfx_api_1.UserError {
    constructor(actionName, error, helpLink) {
        super({
            source: (0, lodash_1.camelCase)(actionName),
            name: errorCode,
            message: error instanceof depCheck_1.DepsCheckerError ? error.message : (0, localizeUtils_1.getDefaultString)(messageKey),
            displayMessage: error instanceof depCheck_1.DepsCheckerError ? error.message : (0, localizeUtils_1.getLocalizedString)(messageKey),
            helpLink: helpLink,
        });
    }
}
exports.FuncInstallationUserError = FuncInstallationUserError;
//# sourceMappingURL=funcInstallationUserError.js.map